/**
 * Mutation to update marketplace_org
 */
const updateOrgMutation = `
mutation UpdateMarketplaceOrg($id: ID!, $fields: UpdateMarketplace_orgFieldsInput) {
  updateMarketplace_org(input: { id: $id, fields: $fields }) {
    marketplace_org {
      objectId
      name
      marketplace_seller_pointer {
        objectId
        name
      }
    }
  }
}`.replace(/\r?\n|\r/g, "").replace(/\t/g, " ");

export default updateOrgMutation;
